package com.vamvisions.main.portfolio.domain.model

/**
 * A listed project. [description] may be empty. [featured] marks current work. [meta] is a short localized line shown
 * above the name, or null. [iconUrl] is a site-relative path. [storeLinks] are its store pages in display order, at
 * most one per store. [websiteUrl] is the absolute URL of its live website, for a project used online. [sourceUrl] is
 * the absolute URL of its public source code. [privacyPolicySlug] is the slug of its privacy-policy document.
 */
data class Project(
    val slug: String,
    val name: String,
    val description: String,
    val year: Int,
    val status: ProjectStatus,
    val featured: Boolean,
    val meta: String?,
    val iconUrl: String,
    val storeLinks: List<StoreLink>,
    val websiteUrl: String?,
    val sourceUrl: String?,
    val privacyPolicySlug: String?,
    val skills: List<Skill>,
)

/** Whether a [Project] is out, or still being built. */
enum class ProjectStatus { PUBLISHED, COMING_SOON }
